<app-navbar></app-navbar>

<mat-card class="table-container">
  <div class="dashboard-header">
    <mat-card-title>
      <button class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      Processed Output
    </mat-card-title>
    <div class="dashboard-buttons">
      <button mat-raised-button matTooltip="Download the processed CSV file 📩" class="download-button" (click)="downloadCSV()">
        <mat-icon>download</mat-icon>
      </button>
      <button mat-raised-button matTooltip="Visualize the insights from the processed CSV 📈" class="download-button" (click)="navigateDashboard()">
        Visualize
      </button>
    </div>
  </div>

  <div class="table-wrapper">
    <table mat-table *ngIf="displayedColumns.length > 0" [dataSource]="dataSource" class="mat-elevation-z8">

      <!-- Dynamic Column Generation -->
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef> {{ column }} </th>
        <td mat-cell *matCellDef="let row">
          <span [ngClass]="{'negative-value': isNegative(row[column])}">
            {{ row[column] }}
          </span>
        </td>
      </ng-container>

      <!-- Table Headers & Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- No Data Message -->
      <tr *ngIf="dataSource.data.length === 0">
        <td [attr.colspan]="displayedColumns.length" class="no-data">No data available</td>
      </tr>

    </table>
  </div>
</mat-card>
